import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/proveedores',documento:'catalogs',acceso:'sesion',filas:['074'],cita:'Areas/Catalogs/Controllers/ProvidersController.cs:32'} satisfies RutaProd;
